
let properties_page = document.querySelector('#properties-list-page')

if (properties_page) {
    let filter_form = properties_page.querySelector('#properties-filter')
    



    
}